import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import PracticeAreas from "@/pages/PracticeAreas";
import Damages from "@/pages/Damages";
import ServiceAreas from "@/pages/ServiceAreas";
import Contact from "@/pages/Contact";
import CaseEvaluator from "@/pages/CaseEvaluator";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route
                            path="/practice-areas"
                            element={<PracticeAreas />}
                        />
                        <Route path="/damages" element={<Damages />} />
                        <Route
                            path="/service-areas"
                            element={<ServiceAreas />}
                        />
                        <Route path="/contact" element={<Contact />} />
                        <Route
                            path="/case-evaluator"
                            element={<CaseEvaluator />}
                        />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#11203D",
                        color: "#F7F5EB",
                        border: "1px solid #1F3458",
                        borderRadius: 0,
                    },
                }}
            />
        </div>
    );
}

export default App;
